// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1VzwW","search":"Settings_search__3Bn8G","filter":"Settings_filter__3n9zr"};